import React,{useRef, useState, useEffect} from "react";
import { Button} from "react-bootstrap";

class EditNow extends React.Component {

	clickDebouncer = null;
	
	constructor(props) {
		
		super(props);
		
		
		this.state = {
			edit:this.props.edit,
			suffix:this.props.suffix ?? '',
			singleClick:this.props.singleClick ?? false,
			value:this.props.value,
			buffer:this.props.value,
			valid:true
		};
		
	}

	updateStatus(s){
		var x = {...this.state, ...s};
		this.setState(x);
		this.forceUpdate();
	}
	handleDoubleClick(e){
		e.stopPropagation();
		this.updateStatus({edit:true});
		clearTimeout(this.clickDebouncer);
		this.clickDebouncer = null;
		setTimeout(()=>{
			
			this.element.focus();
			this.element.select();
		},200);
		
	}
	isValid(value) {
		
		if(!this.props.validate)
			return true;
		
        return this.props.validate(value);
	}
	handleOnClick(e){
		e.stopPropagation();
		
		if(this.state.singleClick)
			return this.handleDoubleClick(e);
		
		if(this.props.onClick){
			
			if(!this.clickDebouncer){
				this.clickDebouncer = setTimeout(()=>{
					this.props.onClick(e);
				},300);
			}
		}
	}
	handleInputClick(e){
		e.stopPropagation();
	}
	handleOnBlur(e){
		var newValue = e.target.value;
		var valid = this.isValid(newValue);
		
		this.updateStatus({edit:false, value:newValue, buffer:newValue, valid:valid});
		
		if(this.props.onUpdate && valid)
			this.props.onUpdate(newValue);
	}
	handleOnChange(e){
		var newValue = e.target.value;
		var invalid = false;
		
		this.updateStatus({buffer:newValue, valid:this.isValid(newValue)});
	}
	handleOnKeyUp(e){
		if (e.key === 'Enter' || e.keyCode === 13) {
			this.handleOnBlur(e);
		}
		if (e.key === 'Escape' || e.keyCode === 27) {
			
			this.updateStatus({edit:false, buffer:this.state.value});
		}
	}
	componentDidMount(){
		if(this.element && this.state.edit){
			this.element.focus();
			this.element.select();
		}
	}
	componentDidUpdate(prevProps, prevState, snapshot){
		
		
		
		
	}
	render() {
		
		var auto = this.state.edit ? 'autoFocus' : '';
		
		return this.state.edit ? (
			<input id={"edit-dynamic-"+this.props.id} className={"editinplace " + (this.state.valid ? '' : 'invalid') + ' ' + this.props.className}
				ref={(e)=>{this.element = e;}}
				type="text"
				onClick={(e)=>{this.handleInputClick(e);}}
				value={this.state.buffer}
				onChange={(e)=>{this.handleOnChange(e);}}
				onBlur={(e)=>{this.handleOnBlur(e)}}
				onKeyUp={(e)=>{this.handleOnKeyUp(e)}}
			/>
		) : (
			<span id={"edit-static-"+this.props.id} className={"editinplace " +(!this.props.value && this.props.placeholder ? "place-holder " : "") + (this.state.valid ? '' : 'invalid')  + ' ' + this.props.className} title={this.props.value} onClick={(e)=>{this.handleOnClick(e);}} onDoubleClick={(e)=>{this.handleDoubleClick(e)}}>
			  {this.state.buffer.length ? this.state.buffer : this.props.placeholder}{this.state.suffix}
			</span>
		);
			
		
	}
}

export default EditNow;